// Lib
import { put, select, takeEvery } from 'redux-saga/effects';

// TODO: Install @reduxjs/toolkit types if needed
interface PayloadAction<T> {
  type: string;
  payload: T;
}

// Api
import client from '@api';
import { ErrorCategory, handleError } from '@services/errorService';

// Actions
import { AddPost, GetPost } from '@actions/posts';

// Graph
import { getPostQuery } from '@graphql/queries/post';

// Types
import type { RootState } from '@app-types/index';
import type { GqlPostOutput } from '@app-types/graphql';

interface PostQueryResult {
  data: {
    postById: GqlPostOutput & { accountId?: string };
  };
}

function* getPostSaga(action: PayloadAction<string>): Generator {
  try {
    const postId = action.payload;
    const post = (yield select(
      (state: RootState) => state.Posts[postId as keyof typeof state.Posts],
    )) as unknown;

    if (!post) {
      const result = (yield client().query({
        query: getPostQuery,
        variables: { postId },
      })) as PostQueryResult;

      const { postById } = result.data;

      yield put(AddPost({ post: postById, accountId: postById?.accountId }));
    }
  } catch (error) {
    handleError(error, { category: ErrorCategory.GRAPHQL, silent: true });
  }
}

function* postSaga(): Generator {
  yield takeEvery(GetPost.toString(), getPostSaga);
}

export default postSaga;
